import React, { useState, useEffect, useCallback } from "react";
import { setTitle } from "../../helpers/MetaTag";
import Button from "../../components/form/Button";
import NoDataFound from "../../components/NoDataFound";
import toastr from "toastr";
import { useSelector } from "react-redux";
import Accordian from "../../components/Common/Accordian";
import Search from "../../components/form/Search";

import { postData } from "../../services/api";
import { Document, pdf, PDFDownloadLink } from "@react-pdf/renderer";
import TrialAlertPopup from "../../components/popup/TrialAlertPopup";
import { API_URL } from "../../config/host";

import { useTranslation } from "react-i18next";
import { classNames } from "../../helper/classNames";
import PositionCompetenciesSkelton from "../../components/loader/PositionCompetenciesSkelton";
import { Tooltip } from "react-tooltip";
import DeletePopup from "../../components/DeletePopup";
import ConfirmationPopup from "../../components/popup/ConfirmationPopup";
import BoardPositionPopup from "../../components/popup/BoardPositionPopup";
import BoardPositionReport from "./../pdf/BoardPositionReport";

const BoardCompetencies = () => {
  setTitle(
    "Succession Planning Software for your Business with Succession Now | Succession Plan Position Competencies"
  );
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth?.user);
  const isTrial = localStorage.getItem("isTrial");
  const [loading, setLoading] = useState(true);
  const [competenciesData, setCompetenciesData] = useState([]);
  const [reload, setReload] = useState(false);
  const [openAccordionId, setOpenAccordionId] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [allData, setAllData] = useState([]);
  const [enabledTrialPopup, setEnabledTrialPopup] = useState(false);
  const [actionValue, setActionValue] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);
  const [enabledDeletePopup, setenabledDeletePopup] = useState({
    isOpen: false,
    data: null,
  });
  const [enabledConfirmationPopup, setEnabledConfirmationPopup] =
    useState(false);
  const [enabledBoardPositionPopup, setEnabledBoardPositionPopup] =
    useState(false);
  const [details, setDetails] = useState({});

  const loadList = useCallback(async () => {
    setLoading(true);
    setIsDisabled(true);
    try {
      const result = await postData("position/list", {
        sortQuery: { ordering: 1 },
        status: 1,
        isBoardMember: 1,
      });
      if (result.data) {
        setCompetenciesData(
          result.data
            .sort((a, b) => {
              if (a?.company_id === null && b?.company_id !== null) {
                return -1;
              }
            })
            .map((value) => {
              return {
                ...value,
                position_competencies: value?.company_position_competencies
                  ? value?.company_position_competencies
                  : value?.position_competencies,
                different_competencies: value?.different_competencies
                  ? value?.different_competencies
                  : "",
              };
            })
        );
        setLoading(false);
        setIsDisabled(false);
      } else {
        console.log("Position message", result.message);
        setLoading(false);
      }
    } catch (error) {
      console.log("Error role catch", error.message);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadList();
  }, [loadList]);

  const getDownload = (e) => {
    e.preventDefault();
    if (e.target.tagName.toLowerCase() === "a") {
      window.open(e.target.href, "_blank");
    }
  };

  const toggleAccordion = (id) => {
    setOpenAccordionId(openAccordionId === id ? null : id);
  };

  useEffect(() => {
    if (keyword) {
      const filteredArray = competenciesData.filter((item) =>
        item?.name?.toLowerCase().includes(keyword.toLowerCase())
      );
      setAllData(filteredArray.sort((a, b) => a.name?.localeCompare(b.name)));
    } else {
      setAllData(
        competenciesData.sort((a, b) => a.name?.localeCompare(b.name))
      );
    }
  }, [competenciesData, keyword]);

  useEffect(() => {
    if (actionValue && actionValue.button_type === "delete") {
      const loadDeleteRecord = async () => {
        setReload(true);
        try {
          const deleteData = await postData("position/delete", {
            id: actionValue?.row_id,
          });
          if (deleteData.data) {
            loadList();
            toastr.success("Board position deleted successfully");
          } else {
            toastr.error(deleteData?.message);
          }
        } catch (error) {
          toastr.error(error.message);
        }
        setReload(false);
      };
      loadDeleteRecord();
    }
  }, [actionValue]);

  const splitToList = (text) =>
    text
      .split("\n")
      .map((item) => item.trim())
      .filter((item) => item.length > 0);

  const handleSingleDownloadClick = async (e, item, index) => {
    e.preventDefault();

    // Open a blank tab immediately to avoid pop-up blockers.
    const newTab = window.open("", "_blank");

    // Display a styled loading message with Tailwind CSS.
    newTab.document.write(`
            <html lang="en">
              <head>
                <script src="https://cdn.tailwindcss.com"></script>
                <style>
                  body {
                    @apply bg-gray-100;
                    margin: 0;
                    height: 100vh;
                  }
                  .loader-container {
                    @apply flex flex-col justify-center items-center h-screen;
                  }
                  .loader {
                    width: 50px;
                    aspect-ratio: 1;
                    display: grid;
                    border-radius: 50%;
                    background:
                      linear-gradient(0deg, rgb(0 0 0 / 50%) 30%, #0000 0 70%, rgb(0 0 0 / 100%) 0) 50% / 8% 100%,
                      linear-gradient(90deg, rgb(0 0 0 / 25%) 30%, #0000 0 70%, rgb(0 0 0 / 75%) 0) 50% / 100% 8%;
                    background-repeat: no-repeat;
                    animation: l23 1s infinite steps(12);
                  }
                  .loader::before,
                  .loader::after {
                    content: "";
                    grid-area: 1 / 1;
                    border-radius: 50%;
                    background: inherit;
                    opacity: 0.915;
                    transform: rotate(30deg);
                  }
                  .loader::after {
                    opacity: 0.83;
                    transform: rotate(60deg);
                  }
                  @keyframes l23 {
                    100% {
                      transform: rotate(1turn);
                    }
                  }
                </style>
              </head>
              <body>
               <div class="flex justify-center items-center mt-20 loader-container">
                <div class="flex flex-col items-center justify-center space-y-4">
                  <div class="loader"></div>
                  <p class="text-teal-700 text-lg font-semibold mt-4">Generating your PDF... Please wait.</p>
                </div>
               </div>
              </body>
            </html>
            `);

    try {
      // Generate the PDF blob asynchronously.
      const blob = await pdf(
        <Document>
          <BoardPositionReport
            data={[item]}
            user={user}
            companyLogo={API_URL + user?.image}
          />
        </Document>
      ).toBlob();

      // Create a URL from the blob.
      const blobURL = URL.createObjectURL(blob);
      // Redirect the new tab to the blob URL (load the PDF).
      newTab.location.href = blobURL;
    } catch (error) {
      // Display an error message in the new tab.
      newTab.document.body.innerHTML = `
              <div class="flex flex-col items-center justify-center h-screen bg-red-100">
                <p class="text-red-700 text-lg font-semibold">Failed to load PDF. Please try again later.</p>
                <p class="text-sm text-gray-600">${error.message}</p>
              </div>
            `;
      console.error("PDF generation error:", error);
    }
  };

  return (
    <>
      <div className="relative flex justify-between items-center mb-4 flex-wrap sm:flex-nowrap gap-y-4">
        <div className="text-xl md:text-3xl text-slate-800 font-bold">
          {t("board_position_description") + " - "}
          {user?.company_name}
        </div>
        <div className="sm:ml-auto flex justify-end items-center space-x-2">
          {isTrial !== 1 ? (
            <>
              <button
                type={"button"}
                className={classNames(
                  "flex justify-center items-center gap-2 rounded-full bg-teal-500 text-white text-base sm:text-lg h-8 sm:h-10 py-0 px-2 sm:px-3 transition-all duration-200",
                  isDisabled ? "pointer-events-none" : "cursor-pointer"
                )}
                onClick={(e) => getDownload(e)}
                disabled={isDisabled}
              >
                <i className={"fa-fw fa-light fa-cloud-arrow-down"}></i>
                <div
                  className={"text-xs sm:text-sm font-medium whitespace-nowrap"}
                >
                  <PDFDownloadLink
                    document={
                      <Document>
                        <BoardPositionReport
                          data={competenciesData}
                          user={user}
                          companyLogo={API_URL + user?.image}
                        />
                      </Document>
                    }
                    fileName="competencies.pdf"
                  >
                    {({ blob, url, loading, error }) =>
                      loading
                        ? t("loading_document")
                        : t("download_all_position_descriptions")
                    }
                  </PDFDownloadLink>
                </div>
              </button>
            </>
          ) : (
            <>
              <Button
                buttonClasses={"!rounded-full  !bg-black !text-white"}
                buttonLabel={t("download_pdf")}
                buttonType={"button"}
                buttonIcon={"fa-regular fa-download"}
                buttonIconPosition={"left"}
                buttonHasLink={false}
                functions={() => {
                  setEnabledTrialPopup(true);
                }}
              />
              <Button
                buttonClasses={
                  "!bg-slate-200 !text-slate-600 border border-slate-300"
                }
                buttonLabel={t("save")}
                buttonType={"button"}
                buttonIcon={"fa-light fa-check"}
                buttonIconPosition={"left"}
                buttonHasLink={false}
                functions={() => {
                  setEnabledTrialPopup(true);
                }}
              />
            </>
          )}
        </div>
      </div>
      <div className="relative flex justify-between items-center mb-4">
        <div className="relative ml-auto flex justify-end items-center gap-3 w-full sm:w-auto">
          <div className="relative w-full">
            <Search
              placeholder={"Search"}
              setInput={setKeyword}
              divClasses={"!rounded-full"}
            />
          </div>
          <div
            className="sm:ml-auto flex justify-end items-center space-x-4"
            data-tooltip-id={`buttonAddPosition${23323223}`}
            data-tooltip-place="bottom"
          >
            <Button
              buttonType={"button"}
              buttonIcon={"fa-solid fa-plus"}
              buttonIconPosition={"left"}
              buttonLabel={t("add_positions")}
              buttonHasLink={false}
              buttonClasses={
                "!rounded-full !bg-transparent !text-black !border !border-black"
              }
              functions={() => setEnabledBoardPositionPopup(true)}
            />
            <Tooltip
              id={`buttonAddPosition${23323223}`}
              className="!text-xs !bg-teal-500 z-50 rounded py-3 px-6 !opacity-100"
              render={() => (
                <div className="gap-x-1">
                  <div className="text-[13px] font-normal leading-none flex items-center">
                    <div className="font-semibold">Add New Position</div>
                  </div>
                </div>
              )}
            />
          </div>
        </div>
      </div>
      <div className="relative bg-white shadow rounded">
        <div className="">
          <form className="relative divide-y divide-slate-200">
            {allData?.length > 0 ? (
              allData?.map((item, index) => (
                <div className="flex items-start justify-center rounded-lg gap-3">
                  <div className="gap-3 flex-grow flex-shrink">
                    <Accordian
                      key={index}
                      id={index}
                      title={item.name}
                      isOpen={openAccordionId === index}
                      toggleAccordion={toggleAccordion}
                    >
                      <div className="max-w-full mx-auto px-2 py-2  space-y-2">
                        {item?.company_position_competencies && (
                          <>
                            <h1 className="text-base font-bold text-teal-600">
                              Position Summary
                            </h1>

                            <div className="text-gray-700  text-[14px] leading-relaxed">
                              {item?.company_position_competencies || "N/A"}
                            </div>
                          </>
                        )}

                        {item?.key_responsibilities &&
                          Array?.isArray(item?.key_responsibilities) &&
                          item?.key_responsibilities?.length > 0 && (
                            <div className="space-y-3">
                              <h1 className="text-base font-bold text-teal-600">
                                Key Responsibilities:
                              </h1>
                              {item?.key_responsibilities &&
                              Array?.isArray(item?.key_responsibilities) &&
                              item?.key_responsibilities?.length > 0
                                ? item?.key_responsibilities?.map(
                                    (section, index) => (
                                      <div key={index}>
                                        <h2 className="text-[15px] font-semibold text-gray-800 mb-2 border-b border-slate-300">
                                          {section?.title || "N/A"}
                                        </h2>
                                        <ul className="list-disc  text-[14px] list-inside space-y-1 text-gray-700">
                                          {splitToList(
                                            section?.description
                                          ).map((item, idx) => (
                                            <li key={idx}>{item}</li>
                                          ))}
                                        </ul>
                                      </div>
                                    )
                                  )
                                : "N/A"}
                            </div>
                          )}

                        {item?.qualifications && (
                          <div>
                            <h1 className="text-base font-bold text-teal-600">
                              Qualifications
                            </h1>
                            <div className="list-disc text-[14px] list-inside space-y-1 text-gray-700">
                              {splitToList(item?.qualifications)?.map(
                                (item, idx) => (
                                  <div key={idx}>{item}</div>
                                )
                              )}
                            </div>
                          </div>
                        )}
                        {item?.time_commitment && (
                          <div>
                            <h1 className="text-base font-bold text-teal-600">
                              Time Commitment
                            </h1>
                            <div className="list-disc  text-[14px] list-inside space-y-1 text-gray-700">
                              {splitToList(item?.time_commitment)?.map(
                                (item, idx) => (
                                  <div key={idx}>{item}</div>
                                )
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </Accordian>
                  </div>
                  <div className="flex-shrink-0 flex items-start justify-start gap-2 pt-2">
                    <button
                      type={"button"}
                      className={
                        "flex justify-center items-center gap-2 bg-transparent text-black rounded-full text-base sm:text-lg h-8 sm:h-10 py-0 px-2 sm:px-3 transition-all duration-200 cursor-pointer"
                      }
                      onClick={(e) => handleSingleDownloadClick(e, item, index)}
                    >
                      <i className={"fa-fw fa-light fa-cloud-arrow-down"}></i>
                    </button>
                    <div
                      className="cursor-pointer p-1 rounded  transition"
                      onClick={() => {
                        setEnabledBoardPositionPopup(true);
                        setDetails(item);
                      }}
                    >
                      <i className="fa-regular fa-pen text-teal-500 hover:text-teal-700 text-base"></i>
                    </div>
                    {(!item?.code || item?.code !== "ceo") && (
                      <div
                        className="cursor-pointer p-1 rounded transition"
                        onClick={() => {
                          setenabledDeletePopup({
                            isOpen: true,
                            data: item?._id,
                          });
                        }}
                      >
                        <i className="fa-regular fa-trash text-rose-600 hover:text-rose-700 text-base"></i>
                      </div>
                    )}
                  </div>
                </div>
              ))
            ) : loading ? (
              <PositionCompetenciesSkelton />
            ) : (
              <NoDataFound label={"No Data Found"} />
            )}
          </form>
        </div>

        {competenciesData?.length > 0 && (
          <div className="py-3 px-3 border-t border-slate-200">
            <div className="flex items-center justify-end gap-4">
              {isTrial !== 1 ? (
                <></>
              ) : (
                <>
                  <Button
                    buttonClasses={"!rounded-full  !bg-black !text-white"}
                    buttonLabel={t("download_pdf")}
                    buttonType={"button"}
                    buttonIcon={"fa-regular fa-download"}
                    buttonIconPosition={"left"}
                    buttonHasLink={false}
                    functions={() => {
                      setEnabledTrialPopup(true);
                    }}
                  />
                  <Button
                    buttonClasses={
                      "!bg-slate-200 !text-slate-600 border border-slate-300"
                    }
                    buttonLabel={t("save")}
                    buttonType={"button"}
                    buttonIcon={"fa-light fa-check"}
                    buttonIconPosition={"left"}
                    buttonHasLink={false}
                    functions={() => {
                      setEnabledTrialPopup(true);
                    }}
                  />
                </>
              )}
            </div>
          </div>
        )}
      </div>
      {enabledTrialPopup && (
        <TrialAlertPopup
          isOpen={enabledTrialPopup}
          setIsOpen={(val) => setEnabledTrialPopup(val)}
          getActionValue={(obj) => {
            setActionValue(obj);
          }}
        />
      )}
      {enabledDeletePopup && (
        <DeletePopup
          isOpen={enabledDeletePopup?.isOpen}
          setIsOpen={(val) => setenabledDeletePopup({ isOpen: val })}
          currentId={enabledDeletePopup?.data}
          getActionValue={(obj) => {
            setActionValue(obj);
            setenabledDeletePopup({ isOpen: false });
          }}
          setLoading={setReload}
          loading={reload}
        />
      )}
      {enabledBoardPositionPopup && (
        <BoardPositionPopup
          isOpen={enabledBoardPositionPopup}
          setIsOpen={(val) => setEnabledBoardPositionPopup(val)}
          data={details}
          setData={setDetails}
          loadList={loadList}
          isAdmin={true}
        />
      )}
    </>
  );
};

export default BoardCompetencies;
